export default __webpack_public_path__ + "static/media/What makes NFT a great investment.f62bbac7.jpg";